import React from 'react';
import LocationPrediction from '../Models/LocationPrediction';
import { MatchResult } from '../Utils/parseWithKey';

interface LocationDropdownOptionProps {
    parts: MatchResult[];
    option: LocationPrediction;
}

function LocationDropdownOption({ parts, option }: LocationDropdownOptionProps): React.JSX.Element {
    return (
        <div className="flex w-full flex-col gap-1">
            <div className="text-sm leading-normal">
                {parts.map((part) =>
                    part.highlight ? (
                        <strong key={part.key} className="font-semibold">
                            {part.text}
                        </strong>
                    ) : (
                        <span key={part.key}>{part.text}</span>
                    ),
                )}
            </div>
            {option.secondaryText && (
                <div className="text-muted-foreground text-xs leading-normal">{option.secondaryText}</div>
            )}
        </div>
    );
}

export default LocationDropdownOption;
